import { render, staticRenderFns } from "./quotationBox-add-or-update.vue?vue&type=template&id=51e706e5"
import script from "./quotationBox-add-or-update.vue?vue&type=script&lang=js"
export * from "./quotationBox-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./quotationBox-add-or-update.vue?vue&type=style&index=0&id=51e706e5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports